const TR_MAP = {
  'ç': 'c', 'Ç': 'c',
  'ğ': 'g', 'Ğ': 'g',
  'ı': 'i', 'I': 'i',
  'İ': 'i',
  'ö': 'o', 'Ö': 'o',
  'ş': 's', 'Ş': 's',
  'ü': 'u', 'Ü': 'u',
};

// Ürün adını SEO dostu, okunabilir bir URL parçasına çevirir (örn. "Çikolatalı Baklava" -> "cikolatali-baklava")
export const slugify = (text) => {
  if (!text) return '';
  return text
    .split('')
    .map((ch) => TR_MAP[ch] ?? ch)
    .join('')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

// Ürün nesnesinden id göstermeyen, sadece isim slug'ı içeren detay linkini üretir
export const productUrl = (product) => {
  if (!product) return '/products';
  const slug = slugify(product.name);
  return slug ? `/product/${slug}` : `/product/${product.id}`;
};
